import {useTranslation} from "ni18n";
import React, {useEffect, useState} from "react";

import {getCityAndStatesOptions} from "../../utils/stateUtils";
import styles from "./CitiesAutocomplete.module.scss";
import LongAutocomplete, {AutocompleteOnChange} from "./LongAutocomplete";

type Props = {
  onChange: AutocompleteOnChange;
  label?: string;
  grayVariant?: boolean;
  disabled?: boolean;
  onLocate: () => void;
  hideSearchIcon?: boolean;
  clearOnEscape?: boolean;
};

const CitiesAutocomplete: React.FC<Props> = ({
  onChange,
  label,
  onLocate,
  grayVariant,
  disabled,
  hideSearchIcon,
  clearOnEscape,
}): JSX.Element => {
  const [options, setOptions] = useState([]);
  const i18n = useTranslation();

  useEffect(() => {
    getCityAndStatesOptions()
      // @ts-expect-error TS2345: Argument of type 'Dispatch<SetStateAction<never[]>>' is not assignable to parameter of type '(value: string[]) => void | PromiseLike<void>'.
      .then(setOptions)
      .catch(() => setOptions([]));
  }, []);

  const inputStyles = [
    styles.searchbox,
    grayVariant && styles["gray-variant"],
    hideSearchIcon && styles["no-search"],
    !onLocate && styles["no-locate"],
  ]
    .compact()
    .join(" ");

  return (
    <div className="ma pos-r">
      {!hideSearchIcon && (
        <span
          className={`${styles.searchIcon} cIcon-search2 zIndex1 gray800 fs24 pos-a t50pc tty-50`}
          aria-hidden
        />
      )}
      <LongAutocomplete
        {...{options, onChange, label, disabled, clearOnEscape}}
        className={inputStyles}
      />
      {onLocate && (
        <button
          type="button"
          aria-label={i18n.t("Search near me.")}
          className="cp gray800 pos-a-f bg-transparent br50 hover-gray800 hover-bg-gray50 brdn otn top0 bottom0 ma h10 w10 df aic jcc focus-bsDarkBlue3-hug t-100"
          style={{right: 12}}
          onClick={() => {
            onLocate();
          }}
        >
          <span className="cIcon-locArrow fs20 gray600" aria-hidden />
        </button>
      )}
    </div>
  );
};

export default CitiesAutocomplete;
